import React, { Component } from 'react'
import { Radio, message, Badge, Spin } from 'antd'
import { app, api } from "../../app"
import ReviewFailModal from "../../components/ReviewFailModal"
import ReNotice from "./ReNotice"
import ReNews from "./ReNews"
import ReReleaseTrain from "./ReReleaseTrain"

class RePush extends Component {

    constructor (props) {
        super(props)
        this.state = {
            review_visible: false,
            reviewInfo: {},
            sel_tab: 0,
            tabs: [],
            audit: {},
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.getAudit()
        if (this.state.tabs.length > 0) {
            await this.setData({ sel_tab: this.state.tabs[0].val })
        }
    }


    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 审核结果
     * @param audit
     * @param detail
     * @param reviewInfo
     * @param other_params
     * @returns {Promise<boolean>}
     */
    handleCheckReview = async (audit, detail, reviewInfo, other_params) => {
        app.alert('正在审核~', 'loading', '35%', 0)
        const { uri, id, id_key, source } = reviewInfo || this.state.reviewInfo
        let params = {
            audit,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        params[id_key] = id //id
        if (audit === 2) params.detail = detail
        if (other_params && other_params instanceof Object) params = Object.assign(params, other_params)
        const { flag, msg } = await app.post(uri, params)
        message.destroy()
        if (audit === 2) this.CloseReviewModal()
        if (flag === 1) {
            app.alert('审核成功', 'success')
            if (source) source()
            this.getAudit()
            return true
        } else {
            app.alert(msg, 'warn')
            return false
        }
    }

    /**
     * 获取审核统计
     * @returns {Promise<void>}
     */
    getAudit = async () => {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.AuditRights, params)
        if (flag === 1) {
            let tabs = []
            if (data.message_audit === true) {
                tabs.push({ val: "1", name: "通知审核", count: 'message_count' })
            }
            if (data.news_audit === true) {
                tabs.push({ val: "2", name: "新闻审核", count: 'news_count' })
            }
            // if (data.train_audit === true) {
            //     tabs.push({ val: "3", name: "培训审核", count: 'train_count' })
            // }
            this.setData({ tabs, audit: data })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 打开不通过审核对话框
     * @param reviewInfo
     * @constructor
     */
    OpenReviewModal = (reviewInfo) => {
        this.setData({ review_visible: true, reviewInfo })
    }

    /**
     * 关闭不通过审核对话框
     * @constructor
     */
    CloseReviewModal = () => {
        this.setData({ review_visible: false, reviewInfo: {} })

    }

    /**
     * 审核结果
     * @param rule
     * @param value
     * @param callback
     */
    handleReviewResult = (rule, value, callback) => {
        if (value && value.trim() === '') {
            callback('请输入审核失败原因！')
        }
        callback()
    }

    /**
     * Tab按钮变换
     * @param e
     */
    handleTabBtnChange = (e) => {
        const { value } = e.target
        this.setData({ sel_tab: value })
    }

    render () {
        let { review_visible, sel_tab, tabs, audit } = this.state,
            zi_props = {
                successReview: this.handleCheckReview,
                failReview: this.OpenReviewModal,
            }
        let content_node = null
        switch (sel_tab) {
            case "1":   //通知审核
                content_node = (<ReNotice {...zi_props}/>)
                break
            case "2":   //新闻审核
                content_node = (<ReNews {...zi_props}/>)
                break
            case "3":   //新闻审核
                content_node = (<ReReleaseTrain {...zi_props}/>)
                break
            default:
                content_node = (
                    <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                        <Spin size="large" tip="正在加载..."/>
                    </div>
                )
        }
        return (
            <div className="review-info">
                <div className="page-title">发布信息审核</div>
                <div className="page-content">
                    <div className="review-info-tab">
                        <Radio.Group value={sel_tab} buttonStyle="solid" onChange={this.handleTabBtnChange}>
                            {
                                tabs.map((tab, index) =>
                                    <Badge count={audit[tab.count] || 0} key={index}>
                                        <Radio.Button value={tab.val} className='no-select'>{tab.name}</Radio.Button>
                                    </Badge>
                                )
                            }
                        </Radio.Group>
                    </div>
                    <div className="review-info-content">
                        {content_node}
                    </div>
                    <ReviewFailModal visible={review_visible} close={this.CloseReviewModal} label={"失败原因"}
                                     submit={(detail) => this.handleCheckReview(2, detail)}/>
                </div>
            </div>
        )
    }
}

export default RePush



// WEBPACK FOOTER //
// ./src/routes/review/RePush.jsx